import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { DataManager, Visualisation, Toolbar, FilterBar } from 'wc-visualisation';
import { Table, Icon, Popover, formatDate, FieldType, downloadCsv, arrayToCsv } from 'wc-lib';
import { FppUnitDcfTable } from './fpp-unit-dcf-table';
import { NemRegions } from '../config';
import * as screenfull from 'screenfull';
import { fixDecimalColumnsForTable } from './dataUtils';
// import { FPP_RESIDUAL_DCF_THIS_WEEK_testData } from './test-data/FPP_RESIDUAL_DCF_THIS_WEEK-test-data';
// import { FPP_RESIDUAL_DCF_LAST_WEEK_testData } from './test-data/FPP_RESIDUAL_DCF_LAST_WEEK-test-data';
// import { FPP_RESIDUAL_DCF_NEXT_WEEK_testData } from './test-data/FPP_RESIDUAL_DCF_NEXT_WEEK-test-data';
// import { FPP_UNIT_DCF_THIS_WEEK_testData } from './test-data/FPP_UNIT_DCF_THIS_WEEK-test-data';
// import { FPP_UNIT_DCF_LAST_WEEK_testData } from './test-data/FPP_UNIT_DCF_LAST_WEEK-test-data';
// import { FPP_UNIT_DCF_NEXT_WEEK_testData } from './test-data/FPP_UNIT_DCF_NEXT_WEEK-test-data';
// import { FPP_UNIT_PERFORMANCE_THIS_WEEK_testData } from './test-data/FPP_UNIT_PERFORMANCE_THIS_WEEK-test-data';
// import { FPP_UNIT_PERFORMANCE_LAST_WEEK_testData } from './test-data/FPP_UNIT_PERFORMANCE_LAST_WEEK-test-data';
// import { FPP_UNIT_PERFORMANCE_NEXT_WEEK_testData } from './test-data/FPP_UNIT_PERFORMANCE_NEXT_WEEK-test-data';

require('wc-lib/icons/downloadcircle.svg');
require('wc-lib/icons/fullscreen.svg');

@Component({
  template: require('./fpp-historical-performance-and-dcf.html'),
  name: 'fpp-historical-performance-and-dcf',
  components: {
    'vis-visualisation': Visualisation,
    'vis-toolbar': Toolbar,
    'wc-icon': Icon,
    'wc-table': Table,
    'vis-filter-bar': FilterBar,
    'wc-popover': Popover,
    'fpp-unit-dcf-table': FppUnitDcfTable
  }
})
export class FppHistoricalPerformanceAndDcf extends Vue {
  unitPerformanceTab = 'UNIT_PERFORMANCE';
  unitDcfTab = 'UNIT_DCF';

  selectedTab: string = 'UNIT_PERFORMANCE';
  tabs = [{ value: this.unitPerformanceTab, label: 'Unit Historical Performance' }, { value: this.unitDcfTab, label: 'Unit DCF' }, { value: 'RESIDUAL_DCF', label: 'Residual DCF' }]

  selectedUnitDcfRegionId: string = 'NSW1';
  unitDcfRegions: { label: string, value: string }[] = NemRegions;

  selectedInterval: string = 'LAST_WEEK';
  intervals = [{ value: 'LAST_WEEK', label: 'Last Week' }, { value: 'THIS_WEEK', label: 'This Week' }, { value: 'NEXT_WEEK', label: 'Next Week' }]

  dataCache: Record<string, any[]> = {};
  tableData: any[] = [];
  tableColumns: any[] = [];
  csvData: any[] = [];
  csvColumns: any[] = [];
  loadMessage: string = '';

  intervalRefresh: any;

  created() {
    if (screenfull.isEnabled) {
      (screenfull as any).onchange(() => {
        this.isFullscreen = (screenfull as any).isFullscreen;
      });
    }

    this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, true);

    this.intervalRefresh = setInterval(() => {
      this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, true);
    }, 300 * 1000);
  }

  destroyed() {
    clearInterval(this.intervalRefresh)
  }
  
  selectTab(tab: string): void {
    this.selectedTab = tab;
    this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, false);
  }

  @Watch('selectedUnitDcfRegionId')
  onSelectedUnitDcfRegionIdChange(newValue: string, oldValue: string): void {
    this.selectedUnitDcfRegionId = newValue;
    this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, false);
  }

  @Watch('selectedInterval')
  onSelectedIntervalChange(newValue: string, oldValue: string): void {
    this.selectedInterval = newValue;
    this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, false);
  }

  loadData(tab: string, interval: string, regionId: string, clearDataCache: boolean) {
    this.loadMessage = 'Loading data';
    this.fetchDataAsync(tab, interval, clearDataCache).then(
      (data) => {
        let csvColumns = this.getCsvColumns(tab);
        this.tableData = tab !== this.unitDcfTab ? data : data.filter(x => x.RID === regionId);
        this.tableColumns = fixDecimalColumnsForTable(csvColumns, 5);
        this.csvData = data;
        this.csvColumns = csvColumns;
        this.loadMessage = '';
      },
      (error) => {
        this.loadMessage = 'No data found';
      });
  }

  async fetchDataAsync(tab: string, interval: string, clearDataCache: boolean): Promise<any[]> {
    if (clearDataCache) {
      this.dataCache = {};
    }

    let reportName = `FPP_${tab}_${interval}`;

    if (!this.dataCache[reportName]) {
      let id = await DataManager.addEndPoint('../api/report/' + reportName, undefined, 60000, reportName, undefined, 'yyyy-MM-ddTHH:mm:ss', ['ESD', 'EED', 'EFFECTIVE_START_DATETIME', 'EFFECTIVE_END_DATETIME', 'HIST_PERIOD_START_DATETIME', 'HIST_PERIOD_END_DATETIME']);
      let data = DataManager.getDynamicView(id, reportName).data();

      // let data: any[];
      // if (tab === 'RESIDUAL_DCF') {
      //   if (interval === 'LAST_WEEK') data = FPP_RESIDUAL_DCF_LAST_WEEK_testData;
      //   else if (interval === 'THIS_WEEK') data = FPP_RESIDUAL_DCF_THIS_WEEK_testData;
      //   else if (interval === 'NEXT_WEEK') data = FPP_RESIDUAL_DCF_NEXT_WEEK_testData;
      //   data = data.map((x) => ({...x, EFFECTIVE_START_DATETIME: Date.parse(x.EFFECTIVE_START_DATETIME), EFFECTIVE_END_DATETIME: new Date(Date.parse(x.EFFECTIVE_END_DATETIME)) }));
      // }
      // else if (tab === 'UNIT_DCF') {
      //   if (interval === 'LAST_WEEK') data = FPP_UNIT_DCF_LAST_WEEK_testData;
      //   else if (interval === 'THIS_WEEK') data = FPP_UNIT_DCF_THIS_WEEK_testData;
      //   else if (interval === 'NEXT_WEEK') data = FPP_UNIT_DCF_NEXT_WEEK_testData;
      //   data = data.map((x) => ({...x, ESD: Date.parse(x.ESD), EED: new Date(Date.parse(x.EED)) }));
      // }
      // else if (tab === 'UNIT_PERFORMANCE') {
      //   if (tab === 'UNIT_PERFORMANCE' && interval === 'LAST_WEEK') data = FPP_UNIT_PERFORMANCE_LAST_WEEK_testData;
      //   else if (tab === 'UNIT_PERFORMANCE' && interval === 'THIS_WEEK') data = FPP_UNIT_PERFORMANCE_THIS_WEEK_testData;
      //   else if (tab === 'UNIT_PERFORMANCE' && interval === 'NEXT_WEEK') data = FPP_UNIT_PERFORMANCE_NEXT_WEEK_testData;
      //   data = data.map((x) => ({...x, EFFECTIVE_START_DATETIME: Date.parse(x.EFFECTIVE_START_DATETIME), EFFECTIVE_END_DATETIME: new Date(Date.parse(x.EFFECTIVE_END_DATETIME)) }));
      //   data = data.map((x) => ({...x, HIST_PERIOD_START_DATETIME: new Date(Date.parse(x.HIST_PERIOD_START_DATETIME)), HIST_PERIOD_END_DATETIME: new Date(Date.parse(x.HIST_PERIOD_END_DATETIME)) }));
      // }

      this.dataCache[reportName] = data;
    }

    return this.dataCache[reportName];
  }

  getCsvColumns(tab: string): any[] {
    if (tab === 'UNIT_PERFORMANCE') return this.unitPerformanceCsvColumns;
    if (tab === 'UNIT_DCF') return this.unitDcfCsvColumns;
    if (tab === 'RESIDUAL_DCF') return this.residualDcfCsvColumns;
    return null;
  }

  //
  // table
  //

  unitPerformanceCsvColumns = [
    {
      title: 'FPP Unit ID',
      field: 'FPP_UNITID',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Effective Start Date',
      field: 'EFFECTIVE_START_DATETIME',
      formatter: (value) => {
        let date = value.EFFECTIVE_START_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Effective End Date',
      field: 'EFFECTIVE_END_DATETIME',
      formatter: (value) => {
        let date = value.EFFECTIVE_END_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Version #',
      field: 'VERSIONNO',
      fieldType: FieldType.Number,
      sortable: true
    },
    {
      title: 'Historical Period Start Date',
      field: 'HIST_PERIOD_START_DATETIME',
      formatter: (value) => {
        let date = value.HIST_PERIOD_START_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Historical Period End Date',
      field: 'HIST_PERIOD_END_DATETIME',
      formatter: (value) => {
        let date = value.HIST_PERIOD_END_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Regulation Historical Raise Performance',
      field: 'REG_HIST_RAISE_PERFORMANCE',
      fieldType: FieldType.Decimal,
      sortable: true
    },
    {
      title: 'Regulation Historical Lower Performance',
      field: 'REG_HIST_LOWER_PERFORMANCE',
      fieldType: FieldType.Decimal,
      sortable: true
    },
    {
      title: 'FPP Historical Raise Performance',
      field: 'FPP_HIST_RAISE_PERFORMANCE',
      fieldType: FieldType.Decimal,
      sortable: true
    },
    {
      title: 'FPP Historical Lower Performance',
      field: 'FPP_HIST_LOWER_PERFORMANCE',
      fieldType: FieldType.Decimal,
      sortable: true
    },
  ];

  unitDcfCsvColumns = [
    {
      title: 'FPP Unit ID',
      field: 'FUID',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Constraint ID',
      field: 'CID',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Effective Start Date',
      field: 'ESD',
      formatter: (value) => {
        let date = value.ESD || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Effective End Date',
      field: 'EED',
      formatter: (value) => {
        let date = value.EED || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Version #',
      field: 'VN',
      fieldType: FieldType.Number,
      sortable: true
    },
    {
      title: 'Bid Type',
      field: 'BT',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Region ID',
      field: 'RID',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'DCF',
      field: 'DCF',
      fieldType: FieldType.Decimal,
      sortable: true
    },
    {
      title: 'DCF Reason Flag',
      field: 'DRF',
      fieldType: FieldType.Number,
      sortable: true
    },
    {
      title: 'DCF Absolute Negative Performance Total (MWHz)',
      field: 'DANPT',
      fieldType: FieldType.Decimal,
      sortable: true
    },
  ];

  residualDcfCsvColumns = [
    {
      title: 'Constraint ID',
      field: 'CONSTRAINTID',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Effective Start Date',
      field: 'EFFECTIVE_START_DATETIME',
      formatter: (value) => {
        let date = value.EFFECTIVE_START_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Effective End Date',
      field: 'EFFECTIVE_END_DATETIME',
      formatter: (value) => {
        let date = value.EFFECTIVE_END_DATETIME || value;
        return formatDate(date, 'dd/MM/yyyy HH:mm');
      },
      sortable: true
    },
    {
      title: 'Version #',
      field: 'VERSIONNO',
      fieldType: FieldType.Number,
      sortable: true
    },
    {
      title: 'Bid Type',
      field: 'BIDTYPE',
      fieldType: FieldType.String,
      sortable: true
    },
    {
      title: 'Residual DCF',
      field: 'RESIDUAL_DCF',
      fieldType: FieldType.Decimal,
      sortable: true
    },
    {
      title: 'Residual DCF Reason Flag',
      field: 'RESIDUAL_DCF_REASON_FLAG',
      fieldType: FieldType.Number,
      sortable: true
    },
    {
      title: 'DCF Absolute Negative Performance Total (MWHz)',
      field: 'DCF_ABS_NEGATIVE_PERF_TOTAL',
      fieldType: FieldType.Decimal,
      sortable: true
    },
  ];

  download() {
    let rows = this.csvData;
    let columns = this.csvColumns;
    let csv = arrayToCsv(rows, columns);
    downloadCsv(`FPP_${this.selectedTab}_${this.selectedInterval}_${formatDate(rows[0].EFFECTIVE_START_DATETIME, 'yyyyMMddHHmm')}.csv`, csv);
  }

  //
  // full screen
  //

  isFullscreen = false;

  toggleFullscreen() {
    (screenfull as any).toggle();
    setTimeout(() => {
      if (!this.isFullscreen) {
        this.loadData(this.selectedTab, this.selectedInterval, this.selectedUnitDcfRegionId, false);
      }
    }, 2000); // delay gives screen.isFullscreen time to update after screen.toggle()
   }
}


// WEBPACK FOOTER //
// src/views/electricity/fpp/fpp-historical-performance-and-dcf.ts